export interface YouTubeVideo {
  id: number;
  youtube_video_id: string;
  title: string;
  description: string;
  thumbnail_url: string;
  thumbnail_medium_url: string;
  thumbnail_high_url: string;
  channel_title: string;
  published_at: string | null;
  duration: string;
  view_count: number;
  like_count: number;
  category: VideoCategory;
  display_order: number;
  active: boolean;
  featured: boolean;
  admin_notes: string;
  created_at: string;
  updated_at: string;
  metadata_synced_at: string | null;
  embed_url: string;
}

export interface YouTubeChannelVideo {
  video_id: string;
  title: string;
  description: string;
  thumbnail_url: string;
  thumbnail_medium_url: string;
  thumbnail_high_url: string;
  channel_title: string;
  published_at: string | null;
  duration: string;
  view_count: number;
  like_count: number;
  is_saved: boolean;
}

export type VideoCategory = 'tutorial' | 'help' | 'feature' | 'update' | 'general';

export const VIDEO_CATEGORY_LABELS: Record<VideoCategory, string> = {
  tutorial: 'Tutorial',
  help: 'Help',
  feature: 'Feature Walkthrough',
  update: 'App Update',
  general: 'General',
};
